
import { useState } from "react";
import { supabase } from "@/lib/supabase";
import { Button } from "@/components/ui/button";
import { useToast } from "@/hooks/use-toast";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { Key } from "lucide-react";
import PasswordChangeForm from "./password/PasswordChangeForm";

const SecuritySettings = () => {
  const { toast } = useToast();
  const [passwordDialogOpen, setPasswordDialogOpen] = useState(false);

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Key className="h-5 w-5 text-kaija-accent" />
          Turvalisus
        </CardTitle>
        <CardDescription>
          Halda oma konto turvalisust
        </CardDescription>
      </CardHeader>
      <CardContent>
        <Dialog open={passwordDialogOpen} onOpenChange={setPasswordDialogOpen}>
          <DialogTrigger asChild>
            <Button variant="outline">
              Muuda parooli
            </Button>
          </DialogTrigger>
          <DialogContent>
            <DialogHeader>
              <DialogTitle>Muuda parooli</DialogTitle>
              <DialogDescription>
                Sisesta oma praegune parool ja uus parool.
              </DialogDescription>
            </DialogHeader>

            <PasswordChangeForm 
              onSuccess={() => {
                toast({
                  title: "Parool muudetud",
                  description: "Sinu parool on edukalt muudetud.",
                });
                setPasswordDialogOpen(false);
              }}
              onError={(error) => {
                toast({
                  title: "Viga parooli muutmisel",
                  description: error.message || "Midagi läks valesti. Palun proovi uuesti.",
                  variant: "destructive",
                });
              }}
            />
          </DialogContent>
        </Dialog>
        
        <p className="text-sm text-gray-500 mt-4">
          Regulaarne parooli muutmine aitab hoida sinu kontot turvalisena.
          Soovitame valida tugeva parooli, mis sisaldab suurtähti, numbreid ja erisümboleid.
        </p>
      </CardContent>
    </Card>
  );
};

export default SecuritySettings;
